import { css } from '@emotion/core';

import VerdanaRegular from './Verdana/Verdana.ttf';
import BeatriceRegular from './Beatrice/BeatriceRegular.otf';

export default css`
  // Re-brand fonts
  @font-face {
    font-family: 'Verdana_Regular';
    src: local('VerdanaRegular'), url(${VerdanaRegular}) format('truetype');
  }

  @font-face {
    font-family: 'Beatrice_Regular';
    src: local('BeatriceRegular'), url(${BeatriceRegular}) format('opentype');
  }
`;
